module.exports = __webpack_public_path__ + "img/screenshot.491c2609.jpg";